import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { ParticipationStatus } from '../../models/Event'
import { PARTICIPATIONS_STATUSES_URL } from '../../utils/urls'

const fetchParticipationStatuses = (params: TableParams) =>
  SBAPI.FetchPaginated<ParticipationStatus[]>(
    PARTICIPATIONS_STATUSES_URL,
    params
  )

const fetchParticipationStatusById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<ParticipationStatus>(
    `${PARTICIPATIONS_STATUSES_URL}/${id}`,
    params
  )

const createParticipationStatus = (participationStatus: ParticipationStatus) =>
  SBAPI.Post(PARTICIPATIONS_STATUSES_URL, participationStatus)

const updateParticipationStatus = (participationStatus: ParticipationStatus) =>
  SBAPI.Put(
    `${PARTICIPATIONS_STATUSES_URL}/${participationStatus.id}`,
    participationStatus
  )

const deleteParticipationStatus = (participationStatus: ParticipationStatus) =>
  SBAPI.Delete(`${PARTICIPATIONS_STATUSES_URL}/${participationStatus.id}`)

export {
  createParticipationStatus,
  deleteParticipationStatus,
  fetchParticipationStatusById,
  fetchParticipationStatuses,
  updateParticipationStatus,
}
